import {useFilterByLicense} from '@/biz/license.jsx'
import usePreviewUi from './usePreviewUi.jsx'

export default () => {
    const filterByLicense = useFilterByLicense()
    const previewUi = usePreviewUi()

    return (map, nodes) => {
        if (1 < nodes.size) {
            return []
        }

        const [ui] = nodes

        if (! ui.parent) {
            return []
        }

        const onClick = e => {
            const [ui] = nodes
            const target = e.altKey ? '_self' : '_blank'
            previewUi(map, ui, target)
        }

        return [
            filterByLicense('M0003000', {
                key: 'preview',
                label: '界面看板',
                onClick,
            })
        ]
    }
}
